import { SVGProps } from "react"
const DeleteIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 18 20"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.278 7.286h9.444l.002 10.178H4.278V7.286Zm-1.89 10.178c0 1.123.848 2.036 1.89 2.036h9.444c1.042 0 1.89-.913 1.89-2.036V5.25H2.388v12.214ZM11.833 2.4v-.9a1 1 0 0 0-1-1H7.167a1 1 0 0 0-1 1v.9H1.45a.95.95 0 0 0 0 1.9h15.1a.95.95 0 1 0 0-1.9h-4.717Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.167 14.505a.994.994 0 1 0 1.988 0v-4.011a.994.994 0 0 0-1.988 0v4.011ZM9.944 14.505a.994.994 0 1 0 1.989 0v-4.011a.994.994 0 0 0-1.989 0v4.011Z"
            clipRule="evenodd"
        />
    </svg>
)
export default DeleteIcon
